import { GetterTree } from "vuex";
import { RootState } from "@/store/root";

export const getters: GetterTree<any, RootState> = {
	steps(state) {
		return state.steps;
	},
};
